import { gql } from '@apollo/client';

export const GET_PARTNERS = gql`
  query GetPartners {
    partners {
    items {
      partnershipId     #string
      companyBName      
      companyBId
      status
      companyAName      
    }
  }
  }
`;
